import {
  ErrorContent,
  NoContent,
  Pagination,
  PaginationProvider,
} from '@bbl-digital/snorre-v2'
import { useQueryBoardDocumentsQuery } from 'shared/microServices/portalDocuments/portalDocuments.service'
import { useFileuploadPickerContext } from '../../context/useFileuploadPickerContext'
import ArchiveFileItem from '../ArchiveFileItem'
import Loading from './Loading'

const ArchiveFilePickerList = () => {
  const { archiveListPagination, setArchiveListPagination } =
    useFileuploadPickerContext()

  const { data, isLoading, isFetching, isError } = useQueryBoardDocumentsQuery({
    take: archiveListPagination.pageSize,
    skip: archiveListPagination.page * archiveListPagination.pageSize,
  })

  const files = data?.documents
  const total = data?.totalCount

  const showLoading = isLoading || isFetching
  const showFiles = files && files.length > 0 && !showLoading && !isError
  const showNoContent =
    (!files || files.length === 0) && !showLoading && !isError
  const showPagination = files && total > 0 && !isError
  const showError = isError && !showLoading

  return (
    <PaginationProvider
      initialState={{
        total: total,
        pageSize: archiveListPagination.pageSize,
        pageIndex: archiveListPagination.page,
        pageOptions: [5, 10, 20],
      }}
    >
      <div>
        {showLoading && <Loading pageSize={archiveListPagination.pageSize} />}
        {showFiles &&
          files?.map((file) => <ArchiveFileItem key={file.id} file={file} />)}
        {showNoContent && <NoContent text="Fant ingen vedlegg" />}
        {showError && (
          <ErrorContent text="Noe gikk galt ved henting av vedlegg fra arkivet" />
        )}
      </div>
      {showPagination && (
        <Pagination
          onPageSizeChange={(pageSize: number) =>
            setArchiveListPagination({
              ...archiveListPagination,
              pageSize: pageSize,
              page: 0,
            })
          }
          onPageChange={(e) =>
            setArchiveListPagination({ ...archiveListPagination, page: e })
          }
        />
      )}
    </PaginationProvider>
  )
}

export default ArchiveFilePickerList
